// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+d9Lx","envelope":"styles_envelope__ErS62","user_profile_wrapper":"styles_user_profile_wrapper__asEJ2"};